import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar as BootstrapNavbar, Nav, Container, Button, Modal, Form, Image } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { toast } from 'react-toastify';
import logo from '../assets/logo.png';

const Navbar = () => {
  const { user, logout, updateUser } = useAuth();
  const navigate = useNavigate();
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  // Saatler için state
  const [serverTime, setServerTime] = useState('');
  const [turkeyTime, setTurkeyTime] = useState('');

  // Sunucu saatini API'den çek
  const fetchServerTime = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || '';
      const res = await fetch(`${apiUrl}/api/server-time`);
      const data = await res.json();
      setServerTime(new Date(data.serverTime).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit', hour12: false }));
    } catch (err) {
      setServerTime('Hata');
    }
  };

  // Türkiye saatini güncelle
  const updateTurkeyTime = () => {
    const now = new Date();
    setTurkeyTime(
      now.toLocaleTimeString('tr-TR', {
        timeZone: 'Europe/Istanbul',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      })
    );
  };

  useEffect(() => {
    fetchServerTime();
    updateTurkeyTime();
    const serverInterval = setInterval(fetchServerTime, 60000); // 1 dakikada bir sunucu saati güncelle
    const turkeyInterval = setInterval(updateTurkeyTime, 1000); // Her saniye Türkiye saati güncelle
    return () => {
      clearInterval(serverInterval);
      clearInterval(turkeyInterval);
    };
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleShowProfileModal = () => {
    setFormData({
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      password: ''
    });
    setShowProfileModal(true);
    
    // Modal açıldıktan sonra firstName alanını seç
    setTimeout(() => {
      const firstNameInput = document.querySelector('input[name="firstName"]');
      if (firstNameInput) {
        firstNameInput.select();
      }
    }, 100);
  };

  const handleCloseProfileModal = () => {
    setShowProfileModal(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };

      const { data } = await axios.put('/api/auth/update-profile', formData, config);

      if (data.success) {
        updateUser(data.user);

        try {
          const usersResponse = await axios.get('/api/users', config);
          if (usersResponse.data.success) {
            const event = new CustomEvent('usersUpdated', { detail: usersResponse.data.users });
            window.dispatchEvent(event);
          }
        } catch (error) {
          console.error('Kullanıcı listesi güncellenirken hata:', error);
        }

        toast.success('Profil başarıyla güncellendi');
        handleCloseProfileModal();
      }
    } catch (error) {
      const message = error.response?.data?.message || 'Profil güncellenirken bir hata oluştu';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <BootstrapNavbar bg="dark" variant="dark" expand="lg">
        <Container>
          <BootstrapNavbar.Brand as={Link} to="/">
            <Image 
              src={logo} 
              alt="Logo" 
              style={{ height: '36px', width: 'auto', marginRight: '8px' }} 
              className="align-middle"
            />
          </BootstrapNavbar.Brand>
          <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />
          <BootstrapNavbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/">Ana Sayfa</Nav.Link>
              <Nav.Link as={Link} to="/other-reminders">Diğer Hatırlatmalar</Nav.Link>
            </Nav>
            <div className="d-flex align-items-center me-3" style={{ color: '#fff', fontSize: '0.95rem' }}>
              <div className="me-3">
                <span style={{ fontWeight: 500 }}>Sunucu Saati (UTC): </span>
                <span>{serverTime}</span>
              </div>
              <div>
                <span style={{ fontWeight: 500 }}>Türkiye Saati: </span>
                <span>{turkeyTime}</span>
              </div>
            </div>
            <Nav>
              {user && user.isAdmin && (
                <Nav.Link as={Link} to="/admin" className="me-3">Admin</Nav.Link>
              )}
              <Button variant="outline-light" className="me-2" onClick={handleShowProfileModal}>
                Profil
              </Button>
              <Button variant="outline-light" onClick={handleLogout}>
                Çıkış Yap
              </Button>
            </Nav>
          </BootstrapNavbar.Collapse>
        </Container>
      </BootstrapNavbar>

      {/* Profile Modal */}
      <Modal show={showProfileModal} onHide={handleCloseProfileModal}>
        <Modal.Header closeButton>
          <Modal.Title>Profil Bilgileri</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Ad</Form.Label>
              <Form.Control
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
                autoFocus
                autoComplete="off"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Soyad</Form.Label>
              <Form.Control
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
                autoComplete="off"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>E-posta</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                disabled
                autoComplete="off"
              />
              <Form.Text className="text-muted">
                E-posta adresi değiştirilemez.
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Yeni Şifre</Form.Label>
              <Form.Control
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Değiştirmek istemiyorsanız boş bırakın"
                autoComplete="off"
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="w-100" disabled={loading}>
              {loading ? 'Güncelleniyor...' : 'Güncelle'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Navbar;
